import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { TransactionHistory } from "../types";
import TrxBlock from "../common/TrxBlock";
import { Props } from "../../types/global";
import t from "../i18n";
import { Loading } from "../common/Loading";
import { ProductCategory } from "../types-enums";

declare type OrderHistoryState = {
    transactions?: TransactionHistory[]
}
export default class OrderHistory extends React.Component<Props> {
    readonly state: OrderHistoryState = { };
    async componentDidMount() {
        const response = await MyAccountService.fetchPurchaseHistory();
        if (!response) {
            this.props.history.replace("/topup");
            return;
        }
        if (response.responseCode === 0 && response.payLoad) {
            this.setState({ transactions: response.payLoad });
        }
    }
    onRepeat = (sessionId: string, category: ProductCategory) => {
        if(category === ProductCategory.GiftCard)
        {
            this.props.history.push(`/giftcard?sid=${sessionId}&step=summary`);
        }
        else 
        {
            this.props.history.push(`/topup?sid=${sessionId}&step=summary`);
        }
    }
    render() {
        if (!this.state.transactions) return <Loading />;
        return (
            <div className="container small-gutter" style={pageWidth}>
                <div className="form-group form-title">
                    <h2>{t.menu("order_history")}</h2>
                </div>
                <div className="form-group">
                    <div className="row">
                        {this.state.transactions.map(trx => <TrxBlock key={trx.transactionId} trx={trx} onRepeat={this.onRepeat} />)}
                    </div>
                </div>
            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}
